var React = require('react');

function RightArrows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M45.964 41.9705L65.5676 22.4314L45.964 2.89233","stroke":"#ffffff","strokeWidth":"7","key":0}),React.createElement("path",{"d":"M22.986 41.9705L42.5896 22.4314L22.986 2.89233","stroke":"#ffffff","strokeWidth":"7","key":1})]);
}

RightArrows.defaultProps = {"width":"71","height":"45","viewBox":"0 0 71 45","fill":"none"};

module.exports = RightArrows;

RightArrows.default = RightArrows;
